(function() {
  'use strict';

  let fbCurrentCollectionSlide = 0;
  const fbCollectionSlides = document.querySelectorAll('.fb-collection-slide');
  const fbCollectionIndicators = document.querySelectorAll('.fb-collection-indicators .fb-collection-indicator');

  // Hydrate the deferred slide images (data-src) once the carousel nears the
  // viewport - keeps their ~500KB off the wire while the hero LCP image loads.
  if (fbCollectionSlides.length > 0) {
    const fbHydrateSlides = () => {
      fbCollectionSlides.forEach(slide => {
        slide.querySelectorAll('img[data-src]').forEach(img => {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        });
      });
    };
    if ('IntersectionObserver' in window) {
      const fbSlidesIO = new IntersectionObserver((entries) => {
        if (entries.some(e => e.isIntersecting)) {
          fbHydrateSlides();
          fbSlidesIO.disconnect();
        }
      }, { rootMargin: '150px' });
      fbSlidesIO.observe(fbCollectionSlides[0]);
      // Belt-and-braces: the carousel is below the fold, so any user who can
      // see it has scrolled - hydrate on first scroll even if IO never fires.
      window.addEventListener('scroll', fbHydrateSlides, { once: true, passive: true });
    } else {
      fbHydrateSlides();
    }
  }

  // M4: local functions - no longer on window, preventing global namespace pollution
  function fbShowCollectionSlide(n) {
    if (fbCollectionSlides.length === 0) return;

    if (fbCollectionSlides[fbCurrentCollectionSlide]) {
      fbCollectionSlides[fbCurrentCollectionSlide].classList.remove('active');
    }
    if (fbCollectionIndicators[fbCurrentCollectionSlide]) {
      fbCollectionIndicators[fbCurrentCollectionSlide].classList.remove('active');
    }

    fbCurrentCollectionSlide = (n + fbCollectionSlides.length) % fbCollectionSlides.length;

    if (fbCollectionSlides[fbCurrentCollectionSlide]) {
      fbCollectionSlides[fbCurrentCollectionSlide].classList.add('active');
    }
    if (fbCollectionIndicators[fbCurrentCollectionSlide]) {
      fbCollectionIndicators[fbCurrentCollectionSlide].classList.add('active');
    }
  }

  function fbChangeCollectionSlide(direction) {
    fbShowCollectionSlide(fbCurrentCollectionSlide + direction);
  }

  // M4: single event delegation listener on the banner - replaces all inline onclick
  // attributes. Handles SVG child clicks via .closest('[data-fb-action]').
  // Delegation also covers the Space-key path for role="button" elements
  // (Enter already triggers a native click event on focusable elements).
  const banner = document.querySelector('.futbolista-banner');
  if (banner) {
    banner.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-fb-action]');
      if (!btn) return;
      const action = btn.dataset.fbAction;
      if (action === 'scroll-to-collections') {
        document.querySelector('.fb-collections-section')?.scrollIntoView({ behavior: 'smooth' });
      } else if (action === 'slide-prev') {
        fbChangeCollectionSlide(-1);
      } else if (action === 'slide-next') {
        fbChangeCollectionSlide(1);
      } else if (action === 'slide-go') {
        fbShowCollectionSlide(+btn.dataset.fbIndex);
      }
    });
    // Space key does not auto-trigger click on role="button" divs - handle explicitly
    banner.addEventListener('keydown', function(e) {
      if (e.key !== ' ') return;
      const btn = e.target.closest('[data-fb-action]');
      if (!btn) return;
      e.preventDefault();
      btn.click();
    });
  }

  if (fbCollectionSlides.length > 1) {
    let autoPlayInterval = setInterval(function() {
      fbChangeCollectionSlide(-1);
    }, 6000);

    const slider = document.querySelector('.fb-collections-slider');
    if (slider) {
      slider.addEventListener('mouseenter', function() {
        clearInterval(autoPlayInterval);
      });

      slider.addEventListener('mouseleave', function() {
        autoPlayInterval = setInterval(function() {
          fbChangeCollectionSlide(-1);
        }, 6000);
      });

      // M2: touch/swipe - { passive: true } required for Chrome scroll performance
      let touchStartX = 0;
      let touchEndX = 0;
      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      slider.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].clientX;
        const delta = touchStartX - touchEndX; // positive = swipe left = next slide
        if (Math.abs(delta) > 50) {
          fbChangeCollectionSlide(delta > 0 ? -1 : 1);
        }
      }, { passive: true });
    }
  }
})();
